export default __webpack_public_path__ + "static/media/gdpr.5b69a158.webp";